export default __webpack_public_path__ + "static/environment_reduce_box_d-f0a01453f1b8c6054a1f8e14530cb211.png";